import React from 'react';
import { Search } from 'lucide-react';
import { useResearchDemo } from '../../contexts/ResearchDemoContext';
import { researchSources } from '../../data/researchDemo';
import { DemoSectionHeader } from '../demoShell/DemoSectionHeader';
import { focusRing, glassPanel } from '../../utils/demoUi';
import { sourceById } from '../../utils/researchDemo';
import { SourceDetail } from './SourceDetail';
export function SourceLibrary() {
  const {
    state,
    dispatch
  } = useResearchDemo();
  const query = state.ui.search.trim().toLowerCase();
  const results = researchSources.filter(source => !query ? true : [source.title, source.discipline, source.finding].some(field => field.toLowerCase().includes(query)));
  const selected = sourceById(state.ui.selectedSourceId);
  return <div data-id="element-2373" data-mp="3iiixgu14afep">
      <DemoSectionHeader title="Source Library" description="Search the collection by title, discipline or finding. Open a source to read its exact passages and linked relationships." data-id="element-2374" data-mp="3iir80f9rp8mq" />

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]" data-id="element-2375" data-mp="1kejgjc9po7x8">
        <div data-id="element-2376" data-mp="1fedo3tvmahe3">
          <label htmlFor="source-search" className="sr-only" data-id="element-2377" data-mp="1fenfnlwb8wlw">
            Search sources
          </label>
          <div className="relative" data-id="element-2378" data-mp="1aespjkkd0b1w">
            <Search size={18} aria-hidden="true" className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-ink-muted" data-id="element-2379" data-mp="1ahwyswcolwzf" />
            <input id="source-search" type="search" value={state.ui.search} onChange={event => dispatch({
            type: 'setSearch',
            value: event.target.value
          })} placeholder="Search titles, disciplines and findings" className="w-full rounded-lg border border-line bg-white py-2.5 pl-10 pr-3 text-ink-dark focus:border-lavender focus:outline-none focus:ring-2 focus:ring-lavender/20" data-id="element-2380" data-mp="11fns6hkjanrb" />
          </div>
          <p role="status" className="mt-2 text-sm text-ink-muted" data-id="element-2381" data-mp="dptha5jrz99p">
            {results.length} of {researchSources.length} sources
          </p>

          {results.length === 0 ? <p className="mt-4 rounded-xl border border-line bg-white/80 p-6 text-center text-ink-muted" data-id="element-2382" data-mp="83j3h46egd7c">
              No sources match “{state.ui.search}”.
            </p> : <ul className="mt-3 space-y-3" data-id="element-2383" data-mp="3qbidix6mse5p">
              {results.map(source => {
            const active = source.id === selected?.id;
            return <li key={source.id} data-id="element-2384" data-mp="msypy7ywdwh8">
                    <button type="button" aria-pressed={active} onClick={() => dispatch({
                type: 'selectSource',
                id: source.id
              })} className={`w-full rounded-xl border p-5 text-left transition-colors duration-150 ${focusRing} ${active ? 'border-lavender bg-lavender-pale' : 'border-line bg-white/80 hover:bg-white'}`} data-id="element-2385" data-mp="qu0r4ucdkilu">
                      <span className="flex items-center justify-between gap-3" data-id="element-2386" data-mp="1ak48ww04x4vr">
                        <span className="font-mono text-xs font-semibold text-ink-muted" data-id="element-2387" data-mp="1jv9z3gnacuie">{source.id}</span>
                        <span className="text-xs font-medium text-lavender" data-id="element-2388" data-mp="1fuzn9nctb9vm">{source.discipline}</span>
                      </span>
                      <span className="mt-1 block font-heading font-bold text-ink-dark" data-id="element-2389" data-mp="1onjrd3bvi6nu">{source.title}</span>
                      <span className="mt-1 block text-sm leading-relaxed text-ink-muted" data-id="element-2390" data-mp="10xpfop3aio56">{source.finding}</span>
                      <span className="mt-2 block text-xs text-ink-muted" data-id="element-2391" data-mp="wx5gzh32jcgx">
                        {source.design} · {source.population}
                      </span>
                    </button>
                  </li>;
          })}
            </ul>}
        </div>

        <div className="xl:sticky xl:top-28 xl:self-start" data-id="element-2392" data-mp="2masfl639dttj">
          {selected ? <SourceDetail source={selected} data-id="element-2393" data-mp="2hch6ixksfncd" /> : <div className={`${glassPanel} p-10 text-center`} data-id="element-2394" data-mp="2hbz1pck280su">
              <p className="font-heading font-bold text-ink-dark" data-id="element-2395" data-mp="qvwp3c9a8sqr">Select a source</p>
              <p className="mt-2 text-sm text-ink-muted" data-id="element-2396" data-mp="vtokig94ywzp">Its study details, exact passages and linked records appear here.</p>
            </div>}
        </div>
      </div>
    </div>;
}